import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { Dependente } from 'src/app/model/Dependente';
import { Serie } from 'src/app/model/Serie';
import { CarrinhoService } from 'src/app/service/carrinho.service';
import { StorageService } from 'src/app/service/shared/storage.service';
import { DialogComponent } from 'src/app/shared/components/dialog/dialog.component';

@Component({
  selector: 'app-dependente',
  templateUrl: './dependente.component.html',
  styleUrls: ['./dependente.component.scss']
})
export class DependenteComponent implements OnInit {
  public readonly aba: string = 'dependentes';

  public nome_escola!: string;

  public form!: FormGroup;

  public isLoading: boolean = false;

  public anos: Serie[] = [];

  public dependentes: Dependente[] = [];

  public displayedColumns: string[] = [
    'nome_dependente',
    'id_serie',
    'actions'
  ];
  public dataSource!: MatTableDataSource<any>;

  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private storage: StorageService,
    private carrinho: CarrinhoService,
    private dialog: MatDialog
  ) {
  }

  ngOnInit(): void {
    if (this.storage.isloggedIn()) {
      this.nome_escola = JSON.parse(this.storage.getEscola()).nome_escola;
      this.carregaSerie();
      this.initForm();
      this.atualizaListaDependentes();
    } else {
      this.router.navigate(['/'])
    }
  }

  private initForm() {
    this.form = this.formBuilder.group({
      nome_dependente: ['', Validators.required],
      id_serie: ['', Validators.required]
    })
  }

  private carregaSerie() {
	const id_escola = JSON.parse(this.storage.getEscola()).id_escola;
    this.carrinho.listaAno(id_escola).subscribe((res) => this.anos = res);
  }

  public deletaDependente(id: number) {
    this.carrinho.deleteDependente(id).subscribe({
      next: (res) => {
        if (res.status) {
          this.atualizaListaDependentes();
        } else {
          this.dialog.open(DialogComponent, { data: res.mensagem })
            .afterClosed()
        }
      },
      error: (error) => {
        this.dialog.open(DialogComponent, { data: error })
          .afterClosed()
      },
    });
  }

  private atualizaListaDependentes() {
    this.carrinho.listaDependentes(this.storage.getGUID()).subscribe((dependentes) => {
      this.dependentes = dependentes;
      this.dataSource = new MatTableDataSource<Dependente>(dependentes);
      this.dataSource.sort = this.sort;
    });
  }

  public addDependente(form: FormGroup) {
    this.isLoading = true;
    const dados = { ...form.value, guid: this.storage.getGUID() }

    if (this.form.valid) {
      this.carrinho.addDependentes(dados).subscribe({
        next: (res) => {
          if (res.status) {
            this.form.get('id_serie')?.setValue(0);
            this.form.get('nome_dependente')?.setValue(' ');
            this.isLoading = false;
            this.atualizaListaDependentes();
          } else {
            this.dialog.open(DialogComponent, { data: res.mensagem })
              .afterClosed()
          }
        },
        error: () => { console.error('erro ao realizar requisicao') }
      })
    }
  }

  public continuar() {
    if (this.dependentes.length != 0) {
      this.router.navigate(['/lista-material'])
    } else {
      this.dialog.open(DialogComponent, { data: 'Você precisa adicionar, pelo menos, um dependente.' })
    }
  }

  public isInvalid(ctrlName: string): boolean | undefined {
    return this.form.get(ctrlName)?.invalid;
  }

  public mensagemDeErro(ctrlName: string) {
    const field = this.form.get(ctrlName);

    if (field?.hasError('required')) {
      return 'Preencha o campo.';
    } else {
      return '';
    }
  }
}
